import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetAccountGroupsShareInvitedService } from "@/features/accounts/account-group/services/get-account-groups-share-invited-service";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useTradeJumpContext } from "@/features/trade-jump/contexts/trade-jump-context";
import { useContext } from "react";


export const useGetAccountGroupsShareInvited = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  const {
    setInvitedAccountGroups,
  } = useAccountGroupsContext();
  const { syncJump } = useTradeJumpContext();

  const getAccountGroupsShareInvitedService = new GetAccountGroupsShareInvitedService();

  // 口座グループ一覧取得
  const getAccountGroupsShareInvited = async (): Promise<number> => {
    try {
      if (syncJump) {
        setInvitedAccountGroups([]);
        return 0;
      } else {
        const res = await getAccountGroupsShareInvitedService.getAccountGroupsShareInvited({});
        // 口座グループをコンテキストに保存
        const invitations = res.map((item) => ({
          sharedId: item.shared_id,
          ownerId: item.owner_id,
          accountGroupId: item.account_group_id,
          accountGroupName: item.account_group_name,
        }));
        setInvitedAccountGroups(invitations);
        return res.length;
      }
    } catch (error) {
      // エラーハンドリング
      console.log("getAccountGroupsShareInvited:", error);
      return 0;
    } finally {
      //
    }
  };

  return {
    getAccountGroupsShareInvited: errorHandledAsync(getAccountGroupsShareInvited, setError),
  };
};
